import React from "react";

const PartnersComponents = () => {
  return (
    <div className="w-full bg-[rgba(218,_235,_241,_1)]">
      <div className="max-w-[1920px] mx-auto  py-[80px] flex justify-center">
        <div className="w-[924px]  tablet:w-full tablet:max-w-[743px] tablet:px-6 mobile:w-full mobile:max-w-[340px] mobile:px-4">
          {/* Heading */}
          <h2 className="text-center text-[40px] text-[#083545] mobile:text-[28px] mb-10">
            Spominska povezuje družino
          </h2>

          <div
            className="
              grid grid-cols-3 gap-6 tablet:gap-[20px] justify-items-center
              tablet:grid-cols-2 tablet:w-fit tablet:mx-auto
              mobile:grid-cols-1
            "
          >
            {/* ================= CARD 1 ================= */}
            <div
              className="w-full max-w-[292px] h-[288px] tablet:max-w-[292px] tablet:h-[260px]   rounded-2xl border border-white flex justify-center items-center bg-[linear-gradient(92.56deg,_#FFFFFF_0%,_rgba(255,_255,_255,_0.3)_100%)]
            [box-shadow:5px_5px_10px_0px_rgba(194,_194,_194,_0.5)]
            "
            >
              <div className="w-[240px]">
                <img src="/puzzle.png" className="w-[62px] h-[62px]" />
                <h3 className="text-[20px] mt-3 text-[#22281C]">
                  Vsi bližnji lahko sodelujejo
                </h3>
                <p className="text-[14px] text-[#414141] mt-2 leading-[16.5px]">
                  Ker ima spominska svojega skrbnika, je vsem omogočeno
                  dodajanje zgodb, slik in spominov, skrbnik pa na koncu odloči,
                  kaj bo objavljeno in kaj ne.
                </p>
              </div>
            </div>

            <div
              className="w-full max-w-[292px] h-[288px] tablet:max-w-[292px] tablet:h-[260px] rounded-2xl border border-white flex justify-center items-center bg-[linear-gradient(92.56deg,_#FFFFFF_0%,_rgba(255,_255,_255,_0.3)_100%)]
            [box-shadow:5px_5px_10px_0px_rgba(194,_194,_194,_0.5)]
            "
            >
              <div className="w-[240px]">
                <img src="/key.png" className="w-[64px] h-[64px]" />
                <h3 className="text-[20px] mt-3 text-[#22281C]">
                  Stran je lahko je zasebna
                </h3>
                <p className="text-[14px] text-[#414141] mt-2 leading-[16.5px]">
                  Če želi, lahko skrbnik spominsko stran zaklene z geslom, ki ga
                  nato po svoji volji deli naprej in tako določa, kdo ima dostop
                  do strani in kdo ne.
                </p>
              </div>
            </div>

            <div
              className="
                w-full max-w-[292px] h-[288px] tablet:max-w-[292px] tablet:h-[260px] rounded-2xl border border-white flex justify-center items-center
                mobile:order-4
                bg-[linear-gradient(92.56deg,_#FFFFFF_0%,_rgba(255,_255,_255,_0.3)_100%)]
                [box-shadow:5px_5px_10px_0px_rgba(194,_194,_194,_0.5)]
              "
            >
              <div className="w-[240px]">
                <img
                  src="/Gifts.png"
                  className="w-[64px] h-[64px] tablet:w-[66px] tablet:h-[66px]"
                />
                <h3 className="text-[20px] mt-3 text-[#22281C]">
                  Spominska je lahko darilo
                </h3>
                <p className="text-[14px] text-[#414141] mt-2 leading-[16.5px]">
                  Uredite spominsko sami in z njo presenetite dedka ali babico
                  ob naslednji priložnosti. Nobeno drugo darilo ne bo za njih
                  tako dragoceno.
                </p>
              </div>
            </div>

            <div
              className="
                w-full max-w-[340px] h-[280px] tablet:max-w-[292px] mobile:max-w-[292px] tablet:h-[258px] bg-[#083545] rounded-2xl p-6 flex flex-col items-start shrink-0 relative overflow-hidden
                desktop:col-span-2 desktop:w-[608px] desktop:max-w-none desktop:h-auto desktop:flex-row desktop:items-center desktop:gap-[30px] desktop:px-[40px] desktop:py-[35px] desktop:justify-self-start
                desktop:col-start-1 desktop:row-start-2
                mobile:order-5
                [box-shadow:5px_5px_10px_0px_rgba(194,_194,_194,_0.5)]
                border border-white
              "
            >
              <img
                src="/facebook.png"
                className=" mt-[36px] tablet:mt-4  mb-2 desktop:mb-0 desktop:w-[50px] desktop:h-[50px]
                mobile:w-[62px] mobile:h-[62px] tablet:w-[62px] tablet:h-[62px]
                "
              />

              <div className="flex flex-col text-left">
                <h3 className="text-[20px] mb-3 mobile:mb-0 tablet:mb-0 text-white tablet:mt-1  tablet:mt-[6px] ">
                  Spremljajte nas na FB
                </h3>

                <p className="text-[14px]  text-[#FFFFFF] leading-[16.5px] tablet:mt-[9px] tablet:text-[12px] tablet:mr-4">
                  Op. izdelava spominske za najdražje, ki so se poslovili že
                  pred leti, trenutno še ni omogočena, razen občasnih promocij
                  preko partnerjev. Spremljajte nas na FB, da ujamete naslednjo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnersComponents;
